import { QueryCache, QueryClient } from '@tanstack/vue-query'

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError(_error, query) {
      if (query.meta?.vueInstance) {
        const { notificationOptions, redirectTo, vueInstance } = query.meta

        if (notificationOptions) {
          vueInstance.$notify.error({ ...notificationOptions })
        }

        if (redirectTo) {
          vueInstance.$router.push(redirectTo, () => {})
        }
      }
    },
    onSuccess(data, query) {
      if (query.meta) {
        const { successCallback } = query.meta

        if (successCallback) {
          successCallback(data)
        }
      }
    },
  }),
})

const vueQueryPluginOptions = { queryClient, enableDevtoolsV6Plugin: true }

export default vueQueryPluginOptions
